import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))
const New = lazy(() => import('./New'))
const Detail = lazy(() => import('./Detail'))

export const OperationsVolunteerCallsRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--operations--volunteer-calls']}>
    <Route index element={<Index />} />
    <Route path='new' element={<New />} />
    <Route path=':id' element={<Detail />} />
  </SubRouter>
))
